<template>
  <div
    class="modal fade"
    :id="`confirm-${pipeline.id}`"
    tabindex="-1"
    aria-labelledby="devModal"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div v-if="!toDelete" class="modal-content">
        <div class="modal-header">
          <h5 v-if="pipeline.interview.status === 2" class="modal-title" id="devModalLabel">
            Booked interview with
            {{ pipeline.first_name ? pipeline.first_name : getManagerCandidateById.first_name }}
            {{ pipeline.last_name ? pipeline.last_name : getManagerCandidateById.last_name }}
          </h5>
          <h5 v-else class="modal-title" id="devModalLabel">
            Requested interview with
            {{ pipeline.first_name ? pipeline.first_name : getManagerCandidateById.first_name }}
            {{ pipeline.last_name ? pipeline.last_name : getManagerCandidateById.last_name }}
          </h5>
          <button
            ref="closeConfirmModal"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div v-if="pipeline.interview.status === 2" class="modal-body">
          <p>
            Please be aware that there is a scheduled interview with
            <strong
              >{{ pipeline.first_name ? pipeline.first_name : getManagerCandidateById.first_name }}
              {{
                pipeline.last_name ? pipeline.last_name : getManagerCandidateById.last_name
              }}</strong
            >
            <strong>
              {{
                getConfirmedTime(pipeline.interview.timeslots)
                  | formatDate({
                    format: getManagerUserProfile.format_date,
                    timezone: getManagerUserProfile.timezone,
                    hasHourAndMinutes: true,
                  })
              }}
              {{ getManagerUserProfile.timezone_data.utc_timezone }}.
            </strong>
            You can't schedule a new interview before a confirmed interview has taken place (or has
            been cancelled).
          </p>
        </div>

        <div v-else class="modal-body">
          <p>
            You already have a pending request for interview with
            <strong
              >{{ pipeline.first_name ? pipeline.first_name : getManagerCandidateById.first_name }}
              {{
                pipeline.last_name ? pipeline.last_name : getManagerCandidateById.last_name
              }}</strong
            >.
          </p>
        </div>

        <div
          v-if="pipeline.interview.status === 2"
          class="modal-footer text-center justify-content-center"
        >
          <button @click="cancelInterview" type="button" class="btn btn-danger">
            Cancel interview
          </button>
          <button data-bs-dismiss="modal" type="button" class="btn btn-primary">
            Don't cancel interview
          </button>
        </div>
        <div v-else class="modal-footer text-center justify-content-center">
          <button data-bs-dismiss="modal" type="button" class="btn btn-primary">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    pipeline: {
      type: Object,
    },
  },
  data: () => ({
    selectedTimeConfirm: '',
    toDelete: false,
    booking: {
      selectedDates: [''],
      selectedLocation: '1',
      selectedAddress: '',
      videoInstructions: '',
      info: '',
    },
  }),
  methods: {
    cancelInterview() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/interview/cancel`,
          {
            interview_id: this.pipeline.interview.interview_id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeConfirmModal.click();
          this.toDelete = false;
          this.$emit('update');
          this.$toasted.success('Interview cancelled', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {});
    },

    handleClose() {
      this.toDelete = false;
    },

    getConfirmedTime(time) {
      const confirmedSlot = time.find(slot => slot.confirmed_by !== null);
      const confirmedTime = confirmedSlot ? confirmedSlot.time : null;

      return confirmedTime; // "2025-02-13 12:00:00+00"
    },
  },

  computed: {
    ...mapGetters(['getUserProfile']),
    ...mapGetters('managerStoreModule', ['getManagerCandidateById', 'getManagerUserProfile']),
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.book-date {
  display: flex;
  margin-bottom: 15px;
  .form-control {
    margin-bottom: 0 !important;
  }
}
</style>
